require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-the-election-of-the-next-inter-american-development.json") })
        }
      }, "path---en-us-update-the-election-of-the-next-inter-american-development");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-the-election-of-the-next-inter-american-development!./.cache/json/en-us-update-the-election-of-the-next-inter-american-development.json
// module id = 801
// module chunks = 231608221292675